module.exports = __webpack_public_path__ + "static/media/smGreyCircle.e05c5016.svg";